import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56307793"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable-input" }
const _hoisted_2 = { class: "editable-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-edit" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["value", "onKeyup"]

import { ref, computed, watchEffect, nextTick } from 'vue'
import { toast } from '@remote/utils/dialog'

interface IInputBaseRule {
  /** 当前规则名称 */
  name?: string
  /** 是否必填 */
  require?: boolean
  /** 字符串最小长度 */
  min?: number
  /** 字符串最大长度 */
  max?: number
  /** 正则表达式匹配 */
  pattern?: RegExp
}
interface IInputRuleWhenTextChange extends IInputBaseRule {
  /** 校验时机: 前置校验，校验不通过则不修改当前值 */
  timing: 'input'
  /** 自定义校验，若设置此值，则跳过当前规则中其他校验项直接进入自定义校验 */
  validator?: (text: string) => boolean
}
interface ISubmitValidateResult {
  /** 校验结果是否通过 */
  isValid: boolean
  /** 校验结果不通过时的提示文本 */
  message?: string
}
interface IInputRuleWhenSubmit extends IInputBaseRule {
  /** 校验时机: 后置校验，校验不通过则根据message进行提示 */
  timing: 'submit'
  /** 校验不通过时提示的文本 */
  message?: string
  /** 自定义校验，若设置此值，则跳过当前规则中其他校验项直接进入自定义校验 */
  validator?: (text: string) => ISubmitValidateResult
}
type TInputRule = IInputRuleWhenTextChange | IInputRuleWhenSubmit
interface IProps {
  value: string
  editing: boolean
  /** 校验规则 */
  rules?: TInputRule[]
  /** 转换输入结果，若与校验规则同时存在，则先转换后校验 */
  filter?: (text: string) => string
}

interface IEmits {
  (e: 'update:editing', editing: boolean): void
  (e: 'change', text: string, next: (result: boolean) => void): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    value: null,
    editing: { type: Boolean },
    rules: { default: () => ([] as TInputRule[]) },
    filter: { type: Function, default: (text) => text }
  },
  emits: ["update:editing", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:editing', editing: boolean): void
  (e: 'change', text: string, next: (result: boolean) => void): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, editing: boolean, rules: TInputRule[], filter: (text: string) => string }





const inputRef = ref<HTMLInputElement>()
const readonly = computed(() => !props.editing)
const text = ref(props.value)
const errtips = ref('')
watchEffect(() => {
  if (errtips.value) {
    toast({ type: 'error', message: errtips.value })
    errtips.value = ''
  }
})
// 前置校验规则列表
const inputRules = computed(() => props.rules.filter(r => r.timing === 'input'))
const submitRules = computed(() => props.rules.filter(r => r.timing === 'submit'))

function onEdit () {
  emits('update:editing', true)
  nextTick(() => {
    const inputEl = inputRef.value
    if (inputEl) {
      // inputEl.select()
      inputEl.focus()
      inputEl.setSelectionRange(0, inputEl.value.length)
    }
  })
}

function onInput (evt: InputEvent) {
  const inputEl = evt.target as HTMLInputElement
  const value = props.filter(inputEl.value.trim())
  const rules = inputRules.value
  const isOK = rules.every((r: IInputRuleWhenTextChange) => {
    if (typeof r.validator === 'function') {
      return r.validator(value)
    }
    if (!!r.require && !value) return false
    if (typeof r.min === 'number' && value.length < r.min) return false
    if (typeof r.max === 'number' && value.length > r.max) return false
    if (r.pattern && !r.pattern.test(value)) return false
    return true
  })
  if (value !== inputEl.value) {
    inputEl.value = value
  }
  // 校验不通过
  if (!isOK) {
    inputEl.value = text.value
    return
  }
  // 校验通过，修改当前值
  text.value = value
}

function onSubmit () {
  const value = text.value
  if (!value.trim()) {
    emits('update:editing', false)
    text.value = props.value
    return
  }
  if (value === props.value) {
    emits('update:editing', false)
    return
  }

  const rules = submitRules.value
  const isOK = rules.every((r: IInputRuleWhenSubmit) => {
    const ruleName = r.name
    if (typeof r.validator === 'function') {
      const result = r.validator(value)
      if (!result.isValid) {
        errtips.value = result.message || ('当前校验不通过' + (ruleName ? `(${ruleName})` : ''))
        return false
      }
    }
    if (!!r.require && !value) {
      errtips.value = r.message || ('输入不能为空' + (ruleName ? `(${ruleName})` : ''))
      return false
    }
    if (typeof r.min === 'number' && value.length < r.min) {
      errtips.value = r.message || ('输入长度不符合要求' + (ruleName ? `(${ruleName})` : ''))
      return false
    }
    if (typeof r.max === 'number' && value.length > r.max) {
      errtips.value = r.message || ('输入长度不符合要求' + (ruleName ? `(${ruleName})` : ''))
      return false
    }
    if (r.pattern && !r.pattern.test(value)) {
      errtips.value = r.message || ('当前校验不通过' + (ruleName ? `(${ruleName})` : ''))
      return false
    }
    return true
  })
  // 校验不通过
  if (!isOK) return
  emits('change', text.value, (result) => {
    if (result !== false) {
      emits('update:editing', false)
    }
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(readonly))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.value), 1),
          _createElementVNode("span", {
            class: "trigger",
            onClick: onEdit
          }, _hoisted_4)
        ], 64))
      : (_openBlock(), _createElementBlock("input", {
          key: 1,
          ref_key: "inputRef",
          ref: inputRef,
          class: "input",
          placeholder: "请填写设备名称",
          value: text.value,
          onInput: onInput,
          onBlur: onSubmit,
          onKeyup: _withKeys(onSubmit, ["enter"])
        }, null, 40, _hoisted_5))
  ]))
}
}

})